import { Component, OnDestroy, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Observable, combineLatest, of, Subscription } from 'rxjs';
import { map, mergeMap } from "rxjs/operators";
import { ValidatorFn, AbstractControl, FormGroup, FormControl } from "@angular/forms";
import { DwConfigServiceToken, DwConfigService, DwSecurityUserService, DwComponent, DwComponentType, DwMetaDataService,
         DwSectionBaseComponent, DwExpressionService, DwUiConfigRegistryService, DwUIMetaDataConfig,
         DwMetaDataFormApi,
         DwUIMetaDataConfigToken, DwMetaDataServiceToken, DwMetaDataFormStateService, DwFormActionInterceptor } 
        from '@devwareapps/devware-cap';
import { AviatorUser } from '../../../shared/models/aviator-user.model';
import { Inject, Injectable } from "@angular/core";
import { AppMetaDataItemNames, SubscriptionTierBenefitEntity, SubscriptionRoleAllItems, 
         RoSchoolSubscriptionEntity, SubscriptionEntity, SubscriptionStatusAllItems, RoSchoolBillingDetailsEntity  } 
        from '../../../../meta-data/app-meta-data.service';
import { PaymentsRepositoryService } from "src/app/features/payments/services/payments-repository.service";
import { HttpClient } from "@angular/common/http";
import { CreateCustomerResult } from "src/app/features/payments/models/create-customer-result.model";
import { DateTimeUtilService } from '../../../shared/util/date-time-util.service';
import * as moment from "moment";
import { environment } from 'src/environments/environment';
import { EnvironmentConfigItem } from 'src/environments/models/environment-config.model';
import { AppPermissions } from 'src/app/meta-data/app-permissions.enum';
import { AdminManagerService } from 'src/app/features/admin/services/admin-manager.service';

@DwComponent({
    key: 'school-billing-details',
    name: 'School Billing Details',
      componentType: DwComponentType.formSection,
    isGlobal: false,
    parentItemName: AppMetaDataItemNames.FlightSchool,
})
@Component({
    selector: 'school-billing-details',
    templateUrl: './school-billing-details.component.html',
    styleUrls: ['./school-billing-details.component.scss']
})
export class SchoolBillingDetailsComponent extends DwSectionBaseComponent 
    implements OnInit, OnDestroy {

    constructor(
        dwExpressionService: DwExpressionService,
        protected dwUiConfigRegistryService: DwUiConfigRegistryService,
        @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
        @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
        private dwFormStateService: DwMetaDataFormStateService,
        private dwSecurityUserService: DwSecurityUserService,
        private paymentsRepoSvc: PaymentsRepositoryService,
        private adminManagerService: AdminManagerService,
        private dateTimeUtilService: DateTimeUtilService,
        private http: HttpClient,
        @Inject(DwConfigServiceToken) private configService: DwConfigService) 
    {
        super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
        this.paymentsApi = `${configService.coreConfig.apiRoot}/aviator-online/Payments`;
        this.formApi = this.dwFormStateService.state.formApi;
    }

    formApi: DwMetaDataFormApi;
    aviatorUser: AviatorUser;
    paymentsApi: string;
    isFSAdmin: boolean = false;
    test : boolean = false;
    students: RoSchoolBillingDetailsEntity = { Count: 0, _itemName: AppMetaDataItemNames.RoSchoolBillingDetails };
    instructors: RoSchoolBillingDetailsEntity = { Count: 0, _itemName: AppMetaDataItemNames.RoSchoolBillingDetails };
    monthLong: string;
    monthShort: string;
    profitSharing: number;
    profitSharingRate: number;
    setupComponentComplete(){
        this.test = this.isTest();
        this.aviatorUser = this.adminManagerService.getAviatorUser();

        this.isFSAdmin = this.aviatorUser?.user.Permissions.indexOf(AppPermissions.flightSchoolAdmin) > -1;

        if (this.isFSAdmin)
            this.paymentsRepoSvc.getBillingDetails(this.aviatorUser.FlightSchoolId)
                .subscribe(bd => {
                    this.instructors = bd.find(b => b.SubscriptionRoleId == SubscriptionRoleAllItems.Instructor)
                                        ??  {   _itemName: AppMetaDataItemNames.RoSchoolBillingDetails,
                                                Count : 0, FlightSchoolId: this.aviatorUser.FlightSchoolId }
                    const detail = this.instructors ?? this.students;
                    this.monthLong = detail?.CurrentMonthLong ?? '';
                    this.monthShort = detail?.CurrentMonthShort ?? '';
                    this.profitSharing = detail?.ProfitSharingAmountCurrentMonth ?? 0;
                    this.profitSharingRate = detail?.ProfitSharingRate ?? 0;
                });

        this.formGroup = new FormGroup({
        });
    }
    ngOnInit() {
        if (!this.isFSAdmin)
            return;
    }

    ngOnDestroy(): void {
        for (let subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }

    isTest() : boolean {
        const environments : EnvironmentConfigItem[] = (environment as any).environments;
        if (environments) {
            const environmentKey = (environment as any).environmentKey;
            return environmentKey == 'Test' || environmentKey == 'TestLocal';
        }
        return false;
    }
}
